import {initServicesSlider} from "../section/services/initServicesSlider";
import {initProjectSliders} from "../section/projects/initProjectSliders";
import {showProjectMoreDetails} from "../section/projects/showProjectMoreDetails";
import {hideProjectMoreDetails} from "../section/projects/hideProjectMoreDetails";
import {showFullScreenImage} from "../helpers/showFullScreenImage";
import {toggleHeader} from "../helpers/toggleHeader";
import {toggleServiceMore} from "../section/services/toggleServiceMore";
import {toggleScroll} from "../helpers/toggleScroll";
import {stopPreviewVideo} from "../section/preview/stopPreviewVideo";
import {initPageVideo} from "../section/preview/initPageVideo";
import {initTeamSliderBig, initTeamSliderSmall} from "../section/team/initTeamSlider";
import {initForm} from "../form/initForm";
import {toggleModalForm} from "../helpers/toggleModalForm";
import {toggleModalFormStatus} from "../helpers/toggleModalFormStatus";
import {initReviewsSlider} from "../section//reviews/initReviewsSlider";

document.addEventListener('DOMContentLoaded', function() {
    if (window.innerWidth < 1240) {
        document.body.style.overflow = null;
        document.querySelector('.preview').remove();
    }

    if (window.innerWidth >= 1240) {
        initPageVideo();
        initTeamSliderSmall();
    }

    if (window.innerWidth < 768) {
        initReviewsSlider();
    }

    toggleHeader();
    initServicesSlider();
    initProjectSliders();
    initTeamSliderBig();
    initForm();
    initHeader();
})

document.addEventListener('click', function(evt) {
    if (evt.target.closest('.modal .btn-close')) {
        if (evt.target.closest('.modal-image')) {
            document.querySelector('.projects .projects__foot-wrapper ').style.overflow = null;
            document.querySelector('.modal-image').classList.add('none');
            showFullScreenImage();
        }

        if (evt.target.closest('.modal-form-status')) {
            toggleModalFormStatus();
        }
    }

    if (evt.target.closest('.show-form')) {
        if (window.innerWidth >= 905) {
            toggleModalForm();
        } else {
            document.querySelector('#end').scrollIntoView({
                behavior: 'smooth'
            });
        }
    }
})

window.addEventListener('scroll', function(evt) {
    toggleHeader();
    toggleHeaderFormBtn();

    if (document.querySelector('.philosophy .content-bottom .content__foot').getBoundingClientRect().y < (window.innerHeight * 2/3)) {
        document.querySelectorAll('.philosophy svg').forEach(item => {
            item.classList.remove('none');
        })
    }
})

document.querySelector('.preview').addEventListener('click', function (evt) {
    if (evt.target.closest('.btn-skip')) {
        stopPreviewVideo(0);
    }
})

document.querySelector('.services').addEventListener('click', function (evt) {
    if (evt.target.closest('.btn-show-more') && evt.target.closest('.slider-info')) {
        toggleServiceMore(evt.target.closest('.slider-info__item').dataset.id);
        toggleScroll(evt.target.closest('.slider-info__item').dataset.id);
    }

    if (evt.target.closest('.btn-back') && evt.target.closest('.slider-more')) {
        toggleServiceMore();
        toggleScroll();
    }
})

document.querySelector('.projects').addEventListener('click', function (evt) {
    if (evt.target.closest('.btn-more') && evt.target.closest('.projects__slider-img')) {
        showProjectMoreDetails(evt);
    }

    if (evt.target.closest('.btn-back') && evt.target.closest('.projects__foot')) {
        hideProjectMoreDetails(evt);
    }

    if (evt.target.closest('.projects__foot') && evt.target.closest('.swiper picture')) {
        let url = evt.target.dataset.original ? evt.target.dataset.original : evt.target.src;

        evt.target.dataset.active = !evt.target.dataset.active;

        if (evt.target.dataset.active) {
            showFullScreenImage(url, evt.target.naturalWidth);
            document.querySelector('.projects .projects__foot-wrapper ').style.overflow = 'hidden';
            document.querySelector('.modal-image').classList.remove('none');
        } else {
            showFullScreenImage()
            document.querySelector('.modal-image').classList.add('none');
        }
    }
})

function initHeader() {
    const header = document.querySelector('.header'),
            btnHeader = document.querySelector('.btn-menu'),
            btnLink = document.querySelector('.btn-link'),
            navigation = document.querySelector('.header nav');

    btnHeader.addEventListener('click', function () {
        header.classList.toggle('open');
        navigation.classList.toggle('show');
    });

    header.querySelectorAll('a').forEach(item => {
        item.addEventListener('click', function () {
            header.classList.toggle('open');
            navigation.classList.toggle('show');
        })
    })

    btnLink.addEventListener('click', function () {
        if (window.innerWidth >= 1240) {
            toggleModalForm();
        } else {
            document.querySelector('#end').scrollIntoView({
                behavior: 'smooth'
            });
            document.querySelector('.header nav').classList.remove('show');
            document.querySelector('.header').classList.remove('open');
        }
    });
}

function toggleHeaderFormBtn() {
    if (document.getElementById('form').getBoundingClientRect().top < (window.innerHeight / 2)) {
        document.querySelector('.btn-link').classList.add('none');
    } else {
        document.querySelector('.btn-link').classList.remove('none');
    }
}
